import React from 'react';
import {INav, INavState} from 'features/layout/redux/helpers/FoldersHelper';
import {useLocation, useParams} from 'react-router-dom';
import {packId, unpackId} from 'common/diplomatIdUtil';
import {infiniteItemHeight, infiniteListClassName} from 'features/layout/SideNav/constant';
import {findIndex, isUndefined} from 'lodash';
import {VFS_PATH, VFS_PATH_LENGTH} from 'common/constants';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export const useEnsureCurrentNodeVisible = (
   data: INav[],
   // expanded: string[],
   setExpanded: (ids: string[]) => void,
   flattened: INavState[]
) => {
   const {pathname} = useLocation();
   const {id, objectType} = unpackId(pathname.slice(1)); // useParams<{id: string; objectType: string}>();
   const isVfs = objectType === DiplomatObjectType.enum.VFS;
   const packedId = pathname.slice(isVfs ? VFS_PATH_LENGTH : 1);

   React.useEffect(() => {
      // console.debug('ensureNodeVisible effect', id, objectType, pathname, data, isVfs);
      if ((objectType && id) || isVfs) {
         const packedId = isVfs ? pathname.slice(VFS_PATH_LENGTH) : packId(objectType, id);
         ensureNodeVisible(data[0], packedId, setExpanded, isVfs);
      }
   }, [id, objectType, pathname, setExpanded, data, isVfs]);

   const flattenedRef = React.useRef(flattened);
   flattenedRef.current = flattened;

   React.useLayoutEffect(() => {
      const currentIndex = findIndex(flattenedRef.current, (f: INavState) => f.id === packedId);
      const offsetHeight = infiniteItemHeight * currentIndex;
      const list = document.getElementsByClassName(infiniteListClassName)[0];
      const listTop = list?.scrollTop;
      if (
         !isUndefined(list) &&
         (offsetHeight < listTop || offsetHeight >= listTop + list?.clientHeight)
      ) {
         list.scroll({top: offsetHeight, behavior: 'smooth'});
      }
   }, [id, objectType, flattenedRef, packedId]);
};

const ensureNodeVisible = (
   data: INav,
   id: string,
   setExpanded: (ids: string[]) => void,
   skipLast: boolean // i.e. to skip vfs node and prevent its fake expand state
) => {
   const idsChain = [] as string[];
   // console.debug(data);
   // console.debug('ensureNodeVisible', data, id, idsChain);
   collectChainToId(data, id, idsChain, skipLast);
   // console.debug('ensureNodeVisible', data, id, idsChain);
   setExpanded(idsChain);
};

const collectChainToId = (node: INav, id: string, idsChain: string[], skipLast: boolean) => {
   if (!node) {
      return;
   }

   if ((node.childObjectType && node.id === unpackId(id).id) || node.id === id) {
      !skipLast && idsChain.push(id);
      return true;
   }

   if (node.child?.find((n) => collectChainToId(n, id, idsChain, skipLast))) {
      idsChain.push(node.id);
      return true;
   }
};
